// extracted by mini-css-extract-plugin
export var circle = "_f2-1";
export var exitConfirmationModal = "_f2-5";
export var iframe = "_f2-0";
export var offline = "_f2-3";
export var online = "_f2-2";
export var workstationSelectError = "_f2-4";